<template>
  <div>
    <ion-list lines="none">
      <ion-item button @click="bookmark">
        <ion-icon color="primary" slot="start" name="bookmark"></ion-icon>
        <ion-label>Add to Notebook</ion-label>
      </ion-item>
      <!-- <ion-item button @click="share">
        <ion-icon color="primary" slot="start" name="share"></ion-icon>
        <ion-label>Share</ion-label>
      </ion-item> -->
      <ion-item button @click="digest">
        <ion-icon color="primary" slot="start" name="list-box"></ion-icon>
        <ion-label>Case Digest</ion-label>
      </ion-item>
      <ion-item button @click="clear" :disabled="!showClearButton">
        <ion-icon color="primary" slot="start" name="trash"></ion-icon>
        <ion-label>Clear Highlights</ion-label>
      </ion-item>
    </ion-list>
  </div>
</template>
<script>
export default {
  props: {
    docId: Number,
    docType: String
  },

  methods: {

    share() {
      //console.log(this.$parent.$data);
      const url = `https://lawyerly.ph/juris/view/${this.docId}`;
      if(this.$isWeb) {
        window.open(url, '_blank').focus();
      } else {
        window.plugins.socialsharing.share(`${this.$parent.$data.title} | Lawyerly`, null, null, url);
      }
    },

    async digest() {

      if(!this.$store.getters['user/isAuthenticated']) {
        this.$router.push('/profile/login');
        return;
      }
      
      var res = await this.$lawyerly.digests.search({
        docid: this.docId,
        doctype: this.docType
      });
      
      if (res.data.count) {
        setTimeout(()=>{
          this.$router.push("/digests/" + res.data.result[0].id);
          this.$ionic.dismissLoading();
        }, 500);
      } else {

        if(this.$parent.$refs["annot8"].state.annotations.length <= 0) {
          this.$ionic.dismissLoading();
          this.$ionic.showAlert(
            "You have not created a digest for this case. \
              To generate a digest, highlight FACTS, ISSUES, RULING from the case.",
            {
              cssClass: "medium-width-alert",
              header: "No Case Digest",
              // subHeader: ,
              buttons: ["Ok"]
            }
          );
          return;
        }

        res = await this.$lawyerly.digests.create({
          docId: this.docId,
          doctype: this.docType,
          public: 0,
          title: this.$parent.$data.title,
          category: '',
          tags: '',
          meta: ''
        });

        if(res) {
          if(res.data) {
             setTimeout(()=>{
              this.$router.push("/digests/" + res.data.id);
            }, 500);
          }
        }
      }
      this.$ionic.dismissPopover();
      this.$ionic.dismissLoading();
    },

    bookmark() {
      this.$root.$emit("header-command", null, { cmd: "add" });
      this.$ionic.dismissPopover();
    },

    clear() {
      this.$ionic.showAlert(
        "All your highlights will be deleted. Are you sure?",
        {
          cssClass: "medium-width-alert",
          header: "Remove Highlights",
          // subHeader: ,
          buttons: [{ text: "Delete", handler: this._clear }, "Cancel"]
        }
      );
      this.$ionic.dismissPopover();
    },

    _clear() {
      this.$parent.$refs["annot8"].eraseAll();
    }
  },

  computed: {
    showClearButton() {
      if(!this.$parent.$refs["annot8"]) {
        return false;
      }
      return this.$parent.$refs["annot8"].state.annotations.length > 0;
    },
  }
};
</script>
